<template>
  <div class="material-uploading">
    <div class="batch-upload-step-third">
      <div class="step-third-circle">
        <img class="img-circle" src="@/assets/image/batch-upload-dialog/ic_circle.png">
        <img class="img-circle-center" src="@/assets/image/batch-upload-dialog/ic_circle_center.png">
        <span class="span-progress">{{ `${matchProgress ? matchProgress.toFixed(2) : 0}%` }}</span>
      </div>
      <div class="step-third-tip" v-if="allFileCount||successFileCount||failFileCount">
        <span class="span-text">文件夹共</span>
        <span class="span-info">{{ allFileCount }}个文件</span>
        <span class="span-text">，匹配成功</span>
        <span class="span-info">{{ successFileCount }}个文件</span>
        <span class="span-text">，匹配失败</span>
        <span class="span-err">{{ failFileCount }}个文件</span>
      </div>
      <div class="step-third-tip" style="height: 24px;" v-else>

      </div>
      <div class="step-third-btn">
        <button class="btn-cancel" @click.stop="clickCancel">取消</button>
        <button class="btn-small" @click.stop="clickSmall">最小化</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'material-uploading',
  components: {},
  props: {
    matchProgress: {
      type: Number,
      default: 0,
    },
    allFileCount: {
      type: Number,
      default: 0,
    },
    successFileCount: {
      type: Number,
      default: 0,
    },
    failFileCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {msg: 'hello'};
  },
  watch: {
    dialogVisible() {
      this.init();
    },
  },
  methods: {
    clickCancel() {
      this.$emit('clickCancel');
    },
    clickSmall() {
      this.$emit('clickSmall');
    },
  },

};
</script>

<style lang="scss" rel="stylesheet/scss">

</style>
